import React, { useEffect, useState, useContext, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import successIcon from "../../assets/Featuredicon.svg";
import logo from "../../assets/home/ProCash.svg";
import { Context } from "../..";
import { tagmanager } from "../../utils/helpers";
//import { removePixels } from "../../utils/helpers";

const REDIRECT = false;

const apiUrl =
  /*"http://127.0.0.1:3331" ||*/ "https://hubspot-proxy-0d8d4ed31dcb.herokuapp.com";

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state;
  const [countdown, setCountdown] = useState(6);
  const [preffered, setPreferred] = useState(undefined);

  const existId = location.state?.existId; // || "96559782522";

  const {
    value: { localizationModule },
  } = useContext(Context);

  function isAppleDevice() {
    return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
  }

  const preferredHandler = useCallback(() => {
    //console.log(preffered, "preffered");
    preffered &&
      existId &&
      window.navigator.sendBeacon(
        `${apiUrl}/leadUpdate?id=${existId}&pid=procash`,
        JSON.stringify({
          properties: { prefered_communication_choice: preffered },
        })
      );
  }, [preffered, existId]);

  useEffect(() => {
    tagmanager("ty-gtag", "G-00LTPXRR8L");
    tagmanager("ty-gtag2", "G-470989317");

    const script = document.createElement("script");
    script.innerHTML = `
        gtag('event', 'conversion', {
            'send_to': 'AW-11530121883/fC7cCNe6sKYaEJvl_vkq',
            'value': 1.0,
            'currency': 'USD'
        });`;
    document.head.appendChild(script);

    return () => {
      window.removeEventListener("beforeunload", preferredHandler);
      document.getElementById("ty-gtag")?.remove();
      document.getElementById("ty-gtag2")?.remove();
    };
  }, []);

  useEffect(() => {
    window.addEventListener("beforeunload", preferredHandler);
    return () => {
      window.removeEventListener("beforeunload", preferredHandler);
    };
  }, [preffered]);

  useEffect(() => {
    if (!REDIRECT) return;
    const timer =
      preffered === "sms" &&
      setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown === 1) {
            clearInterval(timer);
            if (isAppleDevice()) {
              window.location.href = "imessage://procash@a.imsg.tel&body=Hello";
            }
          }
          return prevCountdown - 1;
        });
      }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [preffered]);

  return (
    <div className="max-w-[1110px] mx-auto 3 ">
      <header className="py-4">
        <div className="container mx-auto  px-4">
          <div
            onClick={() => {
              if (data?.fromRegistration) {
                navigate("/");
              } else {
                navigate("/form", {
                  state: { fromThankYouPage: "fromThankYouPage" },
                });
              }
            }}
          >
            <img src={logo} alt="Logo" className="cursor-pointer" />
          </div>
        </div>
      </header>
      <div className="h-[80vh]">
        <div className="flex min-h-full items-center justify-center mx-3 ">
          <div className="relative transform  rounded-lg bg-white shadow-xl sm:w-full sm:max-w-md  md:max-w-md lg:max-w-md xl:max-w-md px-6 pt-8 pb-6 ">
            <div className="bg-white">
              <div className="">
                <div className="flex items-center justify-center">
                  <img src={successIcon} alt="icon" />
                </div>
                <div className="text-center mt-6">
                  <h2
                    id="modal-title"
                    className="text-2xl font-semibold text-[#101828] mb-4"
                  >
                    {localizationModule.getText("thankYouMessage")}
                  </h2>
                  <div className="">
                    <p className="text-[14px] font-medium text-[#303030A3] text-center">
                      {localizationModule.getText("thankYouMessage1")}
                      {/* <span
                        className="cursor-pointer hover:text-[#6853E4] hover:underline "
                        onClick={() =>
                          window.open("mailto:support@procash.ai", "_self")
                        }
                      >
                        support@procash.ai
                      </span> */}
                    </p>
                    <p className="text-[14px] font-bold text-[#030303] text-center m-6">
                      {" "}
                      {localizationModule.getText("thankYouMessage2")}
                    </p>

                    <div
                      style={{
                        display: "inline-flex",

                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <div className="radio-group">
                        <input
                          type="radio"
                          onChange={(e) =>
                            e.target.checked && setPreferred("phone")
                          }
                          name="prefered"
                          value={"call"}
                        />
                        <label htmlFor="">
                          📞{localizationModule.getText("phoneCall")}
                        </label>
                      </div>
                      <div className="radio-group">
                        <input
                          onChange={(e) =>
                            e.target.checked && setPreferred("sms")
                          }
                          type="radio"
                          name="prefered"
                          value={"sms"}
                        />
                        <label htmlFor="">📩 SMS</label>
                      </div>
                    </div>

                    <p className="text-[14px] font-medium text-[#303030A3] text-center m-4 ty-ensure">
                      {localizationModule.getText("thankYouMessage3")}
                    </p>

                    {REDIRECT && isAppleDevice() && (
                      <p className="text-[13px] font-medium text-[#303030e0] text-center mt-4 ">
                        Redirecting to Chat with representative in {countdown}{" "}
                        seconds...
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8 flex  justify-center">
              <button
                type="button"
                onClick={() => {
                  preferredHandler();
                  if (data?.fromRegistration) {
                    navigate("/");
                  } else {
                    navigate("/form", {
                      state: { fromThankYouPage: "fromThankYouPage" },
                    });
                  }
                }}
                className="text-white font-medium text-sm bg-[#5D74F1] py-[14px] px-[26px] rounded-[100px] w-auto hover:bg-blue-400 hover:text-[#000]"
              >
                {localizationModule.getText("returnToTheForm")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
